//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.Continuity.js";
import "../no/SectionList.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[1,"CenterControlFlat",0,"Expression",0],[1,"CenterControlTiltX",0,"Expression",0],[1,"CenterControlTiltY",0,"Expression",0],[1,"CenterControlTrimFlat",0,"Expression",0],[1,"CenterControlX",0,"Expression",0],[1,"CenterControlY",0,"Expression",0],[1,"CenterControlZ",0,"Expression",0],[1,"ConstraintFaces",0,"ScCollector",0],[1,"Continuity",0,"GeometricUtilities.Continuity",0],[0,"CurvatureTolerance",1,0],[0,"FlowDirection",1,0],[1,"InteriorCurveList",0,"SectionList",0],[0,"MergeFaces",1,0],[0,"OrientationVector",1,"Direction",0],[1,"OuterLoop",0,"Section",0],[0,"PositionTolerance",1,0],[0,"RectanglePointFirst",1,"Point",0],[0,"RectanglePointSecond",1,"Point",0],[0,"RectanglePointThird",1,"Point",0],[1,"SpineCurve",0,"Section",0],[0,"TangentTolerance",1,0],[0,"TrimToBoundary",1,0],[0,"Type",1,0],[0,"UVOrientation",1,0]],[],[]];
SPLM.Features.NSidedSurfaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.NSidedSurfaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.NSidedSurfaceBuilder.SurfaceType = Object.freeze({
    "TrimmedPatch" : "TrimmedPatch", "TriangularPatch" : "TriangularPatch"});

SPLM.Features.NSidedSurfaceBuilder.UVOrientationType = Object.freeze({
    "Spine" : "Spine", "Vector" : "Vector", "Area" : "Area"});

SPLM.Features.NSidedSurfaceBuilder.CenterControlType = Object.freeze({
    "Position" : "Position", "Tilting" : "Tilting"});

SPLM.Features.NSidedSurfaceBuilder.CenterControlAxisType = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z", "Flat" : "Flat"});

SPLM.Features.NSidedSurfaceBuilder.FlowDirectionType = Object.freeze({
    "NotSpecified" : "NotSpecified", "Perpendicular" : "Perpendicular", "IsoUVLine" : "IsoUVLine", "AdjacentEdges" : "AdjacentEdges"});

export default SPLM;